module.exports = __webpack_public_path__ + "img/5b9e51b.jpg";